import React from 'react';
import { ILS } from '../../utils/salesUtils';

export default function CashbackCard({ balance, applyAmount, applied, onToggle }) {
    if (!balance || balance <= 0) return null;

    return (
        <div className={`pos-cashback-card${applied ? ' applied' : ''}`}>
            <div className="pos-cashback-ic">⭐</div>
            <div className="pos-cashback-body">
                <div className="pos-cashback-label">Cashback disponible</div>
                <div className="pos-cashback-amount">{ILS(balance)}</div>
            </div>
            <button
                className={`pos-cashback-toggle${applied ? ' on' : ''}`}
                onClick={onToggle}
                aria-pressed={applied}
            >
                {applied ? `Aplicado ${ILS(applyAmount)}` : 'Aplicar'}
            </button>
        </div>
    );
}
